"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _isomorphicUnfetch = _interopRequireDefault(require("isomorphic-unfetch")),
    _default = function () {
  var a = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function a(b) {
    return _regenerator.default.wrap(function (a) {
      for (;;) {
        switch (a.prev = a.next) {
          case 0:
            return a.next = 2, (0, _isomorphicUnfetch.default)(b).then(function (a) {
              return a.json();
            });

          case 2:
            return a.abrupt("return", a.sent);

          case 3:
          case "end":
            return a.stop();
        }
      }
    }, a, this);
  }));
  return function () {
    return a.apply(this, arguments);
  };
}();

exports.default = _default;